
import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction
} from "@/components/ui/alert-dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface DocumentRejectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rejectNotes: string;
  onRejectNotesChange: (notes: string) => void;
  onReject: () => void;
}

export function DocumentRejectionDialog({
  open,
  onOpenChange,
  rejectNotes,
  onRejectNotesChange,
  onReject
}: DocumentRejectionDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reject Document</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to reject this document? The user will need to submit new verification documents.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="py-2">
          <Label htmlFor="rejection-notes" className="mb-2 block">Rejection Notes (Optional)</Label>
          <Textarea
            id="rejection-notes"
            placeholder="Provide a reason for rejection that will be shared with the user"
            value={rejectNotes}
            onChange={(e) => onRejectNotesChange(e.target.value)}
            rows={3}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onReject}
            className="bg-destructive hover:bg-destructive/90"
          >
            Reject
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
